import React from 'react';

import Timer from './timer';

class TimerWidget extends React.Component {
    render() {
        const Difference_In_Time = this.props.date - new Date().getTime();
        if (Difference_In_Time > 0) {
            return (
                <div
                    className={`media-left rounded-xl border border-gray-200 shadow-sm font-sans`}
                    style={this.props.style}
                >
                    <a
                        className="no_decoration"
                        href={this.props.link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <div className="eventCountdownDetailContainer">
                            <div className="detailHeader">
                                <div className="eventSponsorContainer">
                                    <img
                                        alt="img"
                                        className="image img379504"
                                        src={this.props.img}
                                    ></img>
                                </div>
                                <h2 className="eventCountdownTitle">
                                    {this.props.title}
                                </h2>
                            </div>
                            <div className="eventCountdownSponsor">
                                {this.props.sponsor}
                            </div>
                        </div>
                    </a>
                    <div className="eventCountdownDateContainer">
                        <i
                            className="pepicon icon__calendar-month"
                            aria-hidden="true"
                            name="calendar-month"
                        ></i>
                        <div className="eventCountdownDate">
                            {this.props.dateLabel}
                        </div>
                        <Timer date={this.props.date} />
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

export default TimerWidget;
